import React from "react";
import { useTranslation } from "react-i18next";
import FilesTable from "../../components/filesTable";
import { typeFiles } from "../../constants/enum";

const PendingAnswer = () => {
  const { t } = useTranslation();
  const files = [
    {
      name: "material.instructions",
      description: "material.instructionsDescription",
      url: "/download/GeneralDocuments/Instructivo página web WORLDWIDE.pdf",
    },
    {
      name: "MATERIAL PRE-VIAJE WORK&TRAVEL USA",
      description: "material.preTravelHousing",
      url: "https://worldwideturar-my.sharepoint.com/:f:/g/personal/info_worldwidece_com/Eu5qc6aHciJHqJ_v4umuGmMBzg_oqyHuAQqEteP_nivzVQ?e=GZ5kvQ",
      type: typeFiles.video,
    },
  ];

  return (
    <>
      <h2 className="title">{t("general.pendingAnswer")}</h2>
      <FilesTable files={files} />
    </>
  );
};

export default PendingAnswer;
